import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Box, ButtonBase } from '@material-ui/core';

// project imports
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
import logo from '../../../assets/images/logo.png';

// assets
import { IconMenu2 } from '@tabler/icons';

// style constant
const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1
    },
    headerAvatar: {
        ...theme.typography.commonAvatar,
        ...theme.typography.mediumAvatar,
        transition: 'all .2s ease-in-out',
        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
        color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
        '&:hover': {
            background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
            color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
        },
        [theme.breakpoints.up('lg')]: {
            width: '3em', height: '3em'
        },
        [theme.breakpoints.down('lg')]: {
            width: '4em', height: '4em'
        }

    },
    boxContainer: {
        width: '228px',
        display: 'flex',
        [theme.breakpoints.down('md')]: {
            width: 'auto'
        }
    },
    logo: {
        position: 'relative',
        height: '100%'
    },
}));



//-----------------------|| MAIN NAVBAR / HEADER ||-----------------------//


const Header = ({ handleLeftDrawerToggle }) => {
    const classes = useStyles();

    return (
        <React.Fragment>
            {/* logo & toggler button */}
            <div sx={{ display: 'flex' }} style={{ alignItems: 'center' }}>
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1, height: { md: '8vh', lg: '10vh' } }} >
                    <img src={logo} alt="Logo" className={classes.logo} />
                </Box>
            </div>
            <div style={{ marginLeft: '2em' }}>     
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                    <Avatar variant="rounded" className={classes.headerAvatar} onClick={handleLeftDrawerToggle} color="inherit">
                        <IconMenu2 stroke={1.5} size="4rem" />
                    </Avatar>
                </ButtonBase>
            </div>

            <div className={classes.grow} />
            <div className={classes.grow} />
            <ProfileSection />

            {/* mobile header */}
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <MobileSection />
            </Box>
        </React.Fragment>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
